import { useEffect, useState } from "preact/hooks"
import { getProductHandle } from "../utils"
import { useIntersectionObserver } from "./useIntersectionObserver"

const parsePromos = stringHtml => {

    if (!stringHtml) return null;

    const htmlPromos = new DOMParser().parseFromString(stringHtml, 'text/html')
    if(!htmlPromos) return null;

    const productPromosHtml = htmlPromos.querySelector('.product-promos .product-promo');
    const collectionPromosHtml = htmlPromos.querySelector('.product-promos .collection-promo')

    return {
        html: collectionPromosHtml ? collectionPromosHtml.innerHTML : productPromosHtml.innerHTML,
        hasProductPromo: !!productPromosHtml,
        hasCollectionPromo: !!collectionPromosHtml
    }
}

export const usePromos = ({ product }) => {

    const productHandle = getProductHandle(product.url)

    const [promosHtml, setPromosHtml] = useState(null)
    const [isProductPromo, setIsProductPromo] = useState(false)
    const [isCollectionPromo, setIsCollectionPromo] = useState(false)
    const [loadingPromos, setLoadingPromos] = useState(false)
    const [error, setError] = useState("")

    // Loading promos only if element is in view to improve performance
    const [ref, inView] = useIntersectionObserver({
        rootMargin: '100px',
        threshold: 0,
        once: true,
    });
    
    useEffect(() => {
        if (!inView || promosHtml || loadingPromos) return;
        const abortController = new AbortController();

        (async () => {
            try {
                setLoadingPromos(true);
                const res = await fetch(`/products/${productHandle}?section_id=product_promos`, {
                    signal: abortController.signal,
                });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const responseHtml = await res.text();
                const parsedHtml = parsePromos(responseHtml)
                if (parsedHtml) {
                    const {
                        html,
                        hasCollectionPromo,
                        hasProductPromo
                    } = parsedHtml;

                    setPromosHtml(html)
                    setIsCollectionPromo(hasCollectionPromo)
                    setIsProductPromo(hasProductPromo)
                }
            } catch (err) {
                if (err && err.name !== 'AbortError') setError(err.message || 'Fetch failed');
            } finally {
                setLoadingPromos(false);
            }
        })();

        return () => abortController.abort();
    }, [inView])


    return {
        ref,
        promosHtml,
        isCollectionPromo,
        isProductPromo
    }

}